module.exports = __webpack_public_path__ + "img/peisong.bf7f8b3b.png";